import { atom } from 'jotai/vanilla';
import { selectAtom } from 'jotai/vanilla/utils';
import type { ZoomTransform } from 'd3';
import { zoomIdentity } from 'd3-zoom';

const InitialTransform = zoomIdentity.scale(0.1);
export const contentTransformAtom = atom<ZoomTransform>(InitialTransform);

// これより引いたとき、付箋は 6px 未満（文字は 1px 未満）になり、文字が読めない。
// 文字の描画を省いてパン・ズームを軽くする。k=0.09 程度（付箋が約 11px）では文字を表示する
const OVERVIEW_ENTER_SCALE = 0.05;
// 境界付近で拡大・縮小を繰り返したとき、描画の切り替えが何度も起きないよう、戻るしきい値を少し大きくする
const OVERVIEW_LEAVE_SCALE = 0.075;

export const isOverviewScaleAtom = selectAtom<ZoomTransform, boolean>(contentTransformAtom, (transform, previous) =>
  previous ? transform.k < OVERVIEW_LEAVE_SCALE : transform.k < OVERVIEW_ENTER_SCALE
);
